import React, { Component } from "react";
import axios from "axios";
import { Button, Modal, ThemeProvider } from "react-bootstrap";

import "moment/locale/es";
import "antd/dist/antd.css";
import { DatePicker, TimePicker } from "antd";
import $ from "jquery";
import moment from "moment";
import { DataService } from "../../services/data.service";
import { Empty } from "antd";
import { ConfigProvider } from "antd";
import esES from "antd/es/locale/es_ES";
import enUS from "antd/es/locale/en_US";
import Loader from "../loader/loader";
import * as handler from "../utils/handler";
import PrimaryButton from "../utils/primaryButton";
import Slot from "../slot/slot";
var  catid,branch,branchs

const queryString = require("query-string");
var obj;
var datetrim;
var fixdate;
var monthfixed;
var yearfixed;
class SlotModal extends Component {
  runApp = window["app-config"].runApp;
  URL = window["app-config"].URL;
  defaultLanguage = window["app-config"].defaultLang;
  color = window["app-config"].ui.slotScreen;
  slotColor = window["app-config"].ui.slotScreen.fontColor;
  defaultTheme = window["app-config"].applicationProperties.defaultTheme;
  userDetailsConfig = window["app-config"].userDetails;
  runApp = window["app-config"].runApp;
  UI = window["app-config"].ui.userDetailsScreen;
  phoneNumberPrefix = window["app-config"].phoneNumberPrefix;

  isValidEmail = false;
  isValidName = false;
  isValidNumber = false;
  state = {
    selectedDate: moment(new Date()).format("YYYY-MM-DD"),
    data: [],
    nextDates: [],
    appointmentSlots: [],
    dataLoaded: false,
    isCurrentDateSlots: false,
    time:"",
    loader:false,
    lang: {},
  };
  phoneNumRef = React.createRef();
  phoneNumber;
  domainEmailCharacters;
  queryStringlang = queryString.parse(window.location.search);
  startTime = "00";
  endTime = "00";
  lang =
    this.queryStringlang.lang === undefined
      ? this.defaultLang
      : this.queryStringlang.lang;

  dataService = new DataService();
  state = {
    selectedModalDate: moment(new Date()).format("YYYY-MM-DD"),
    selectedModalTime: moment(new Date()).format("hh:mm"),
    dataLoaded: false,
    lang: {},
    showHide: false,
    emailAddress: "",
    phoneNumber: this.phoneNumberPrefix.defaultPhoneNumber,
    name: "",
    branchId: "",
  };

  async componentDidMount() {
    let dates = new Date();
    this.apiforslots(dates);
    this.setState({ lang: handler.setTranslations() });
    this.setPhoneNumberPrefix();
    if (this.runApp.toLowerCase() === "samsung") {
      $(".validate-num").on("keypress", function (event) {
        var regex = new RegExp("^[0-9+]");
        var key = String.fromCharCode(
          !event.charCode ? event.which : event.charCode
        );
        if (!regex.test(key)) {
          event.preventDefault();
          return false;
        }
      });
    }
     branch = await this.dataService.getSingleBranchDetails();
    this.state.branchId = branch.data.branchList[0].BranchID;
    branchs = branch?.data?.branchList[0]?.BranchID;
    catid = localStorage.getItem("catid") !== null ?localStorage.getItem("catid") : "";
  }

  setPhoneNumberPrefix = () => {
    if (
      localStorage.getItem("lang") === "es" &&
      this.phoneNumberPrefix.spain !== ""
    ) {
      this.setState({ phoneNumber: this.phoneNumberPrefix.spain });
    } else if (
      localStorage.getItem("lang") === "ar" &&
      this.phoneNumberPrefix.uae !== ""
    ) {
      this.setState({ phoneNumber: this.phoneNumberPrefix.uae });
    } else if (
      localStorage.getItem("lang") === "en" &&
      this.phoneNumberPrefix.uk !== ""
    ) {
      this.setState({ phoneNumber: this.phoneNumberPrefix.uk });
    } else if (
      localStorage.getItem("lang") === "ur" &&
      this.phoneNumberPrefix.pakistan !== ""
    ) {
      this.setState({ phoneNumber: this.phoneNumberPrefix.pakistan });
    } else {
      this.setState({ phoneNumber: this.phoneNumberPrefix.defaultPhoneNumber });
    }
  };

  handleModalShowHide() {
    this.setState({ showHide: !this.state.showHide });
  }

  saveSlot = async (time) => {
    try {
      console.log("time : ",time)
      if(time !== null && time !== undefined){
        localStorage.setItem("time",time)
        this.setState({time : time})
      }

      this.setState({ dataLoaded: !this.state.dataLoaded });
      if (
        this.state.name == "" ||
        this.state.phoneNumber == "" ||
        this.state.emailAddress == "" ||
        this.state.selectedModalDate == "" ||
        time == ""
      ) {
        handler.showErrMsg2(
          this.state.lang.Error,
          this.state.lang.mandatoryFieldsErr,
          this.state.lang.Ok
        );
        return;
      } else if (
        this.isValidName == false ||
        this.isValidNumber == false ||
        this.isValidEmail == false
      ) {
        handler.showErrMsg2(
          this.state.lang.Error,
          this.state.lang.mandatoryFieldsErr,
          this.state.lang.Ok
        );
        return;
      }
      // else if (this.domainEmailCharacters.match(/^\d+$/)) {
      //   console.log("masla hy isme")
      //   handler.showErrMsg2(
      //     this.state.lang.Error,
      //     this.state.lang.InvalidEmailAddress,
      //     this.state.lang.Ok
      //   );
      //   return;
      // } 
       else if (this.state.time !== null) {
        let response = await this.dataService.saveRequiredUserSlot(
          this.state.name,
          Number(this.state.branchId),
          this.props.category,
          this.state.phoneNumber,
          this.state.emailAddress,
          this.state.selectedModalDate,
          localStorage.getItem("time"),
          this.lang
        );
        console.log(response, "response");
        if (response.data.error !== undefined && response.data.error === true) {
          handler.showErrMsg2(
            this.state.lang.Error,
            this.state.lang.ServerNotResponding,
            this.state.lang.Ok
          );
          this.setState({ dataLoaded: !this.state.dataLoaded });
        } else if (
          response.data.response_code === 100 ||
          response.data.message === "success"
        ) {
          handler.showSuccessMessage(
            this.state.lang.RequestedAppointmentSlot,
            this.state.lang.Ok,
            ""
          );
          this.setState({ dataLoaded: !this.state.dataLoaded });
        } else if (response.data.response_code === 409) {
          handler.showErrMsg2(
            this.state.lang.Error,
            this.state.lang.AlreadyRequestedSlot,
            this.state.lang.Ok
          );

          this.setState({ dataLoaded: !this.state.dataLoaded });
        } else {
          handler.showErrMsg2(
            this.state.lang.Error,
            this.state.lang.SomeThingWentWrong,
            this.state.lang.Ok
          );
          this.setState({ dataLoaded: !this.state.dataLoaded });
        }

        console.log("RESPONSE 121: ", response);
        return;
      } else {

        let response = await this.dataService.saveRequiredUserSlot(
          this.state.name,
          Number(this.state.branchId),
          this.props.category,
          this.state.phoneNumber,
          this.state.emailAddress,
          this.state.selectedModalDate,
          time,
          this.lang
        );
        console.log(response, "response");
        if (response.data.error !== undefined && response.data.error === true) {
          handler.showErrMsg2(
            this.state.lang.Error,
            this.state.lang.ServerNotResponding,
            this.state.lang.Ok
          );
          this.setState({ dataLoaded: !this.state.dataLoaded });
        } else if (
          response.data.response_code === 100 ||
          response.data.message === "success"
        ) {
          handler.showSuccessMessage(
            this.state.lang.RequestedAppointmentSlot,
            this.state.lang.Ok,
            ""
          );
          this.setState({ dataLoaded: !this.state.dataLoaded });
        } else if (response.data.response_code === 409) {
          handler.showErrMsg2(
            this.state.lang.Error,
            this.state.lang.AlreadyRequestedSlot,
            this.state.lang.Ok
          );

          this.setState({ dataLoaded: !this.state.dataLoaded });
        } else {
          handler.showErrMsg2(
            this.state.lang.Error,
            this.state.lang.SomeThingWentWrong,
            this.state.lang.Ok
          );
          this.setState({ dataLoaded: !this.state.dataLoaded });
        }

        console.log("RESPONSE: ", response);
      }
    } catch (error) {
      this.setState({ dataLoaded: true });
      console.log("ERROR: ", error.message);
    }
  };

  onNameChange = (e) => {
    var regex = new RegExp("^[a-zA-ZÀ-ÿñáéíóúü ]+$");
    if (
      ((e.target.value.length === 0 && e.target.value === "") ||
        !regex.test(e.target.value)) &&
      this.runApp.toLowerCase() === "samsung"
    ) {
      $("#firstname-field").css("border-color", "red");
      this.isValidName = false;
    } else if (e.target.value.length === 0 && e.target.value === "") {
      $("#firstname-field").css("border-color", "red");
      this.isValidName = false;
    } else {
      $("#firstname-field").css("border-color", "#dadada");
      this.setState({ name: e.target.value });
      this.isValidName = true;
    }
  };

  onEmailChange = (e) => {
    //this.setState({ emailAddress: e.target.value });

    if (
      !handler.validateEmail(e.target.value) ||
      (e.target.value.length === 0 && e.target.value === "") ||
      /^([\w-\.]+([\w-]+\.)+[\w-]{2,4})?$/.test(e.target.value)
    ) {
      $("#email-field").css("border-color", "red");
      this.isValidEmail = false;
    } else {
      $("#email-field").css("border-color", "#dadada");
      this.setState({ emailAddress: e.target.value });
      this.isValidEmail = true;
      return;
    }

    var str1 = e.target.value.split("@").pop();
    var str2 = str1.split(".");
    this.domainEmailCharacters = str2[0];
    console.log(this.domainEmailCharacters);
  };

  onPhoneChange = (e) => {
    if (
      (e.target.value.length === 0 && e.target.value === "") ||
      e.target.value.length <
        this.userDetailsConfig.phoneNumberField.minLength ||
      /\s/.test(e.target.value) ||
      !e.target.value.charAt(0).includes("+") ||
      !/^[0-9+]+$/.test(e.target.value)
    ) {
      $("#phone-field").css("border-color", "red");
      this.isValidNumber = false;
    } else {
      $("#phone-field").css("border-color", "#dadada");
      this.setState({ phoneNumber: e.target.value });
      this.phoneNumber = this.phoneNumRef.current.value;
      this.isValidNumber = true;
    }
    this.setState({ phoneNumber: e.target.value });
  };
  MONTHCHECKER = (month) => {
    if (month === "Jan") {
      monthfixed = "01";
    } else if (month === "Feb") {
      monthfixed = "02";
    } else if (month === "Mar") {
      monthfixed = "03";
    } else if (month === "Apr") {
      monthfixed = "04";
    } else if (month === "May") {
      monthfixed = "05";
    } else if (month === "Jun") {
      monthfixed = "06";
    } else if (month === "Jul") {
      monthfixed = "07";
    } else if (month === "Aug") {
      monthfixed = "08";
    } else if (month === "Sep") {
      monthfixed = "09";
    } else if (month === "Oct") {
      monthfixed = "10";
    } else if (month === "Nov") {
      monthfixed = "11";
    } else {
      monthfixed = "12";
    }
  };
  apiforslots = async (date) => {
    
    if(branchs !== null && catid !== null && branchs !== undefined && catid !== undefined && branchs !== "" && catid !== ""){
      this.setState({
        loader:true
      })
      let url = `${this.URL.apiUrl}GetAllSlotsOfBranch`;
    if (date !== undefined) {
      let text = `${date}`;
      let month = text.slice(4, 7);
      let year = text.slice(11, 15);
      datetrim = text.slice(8, 10);
      fixdate = datetrim.replaceAll(" ", "-");
      this.MONTHCHECKER(month);
      obj = {
        BranchID: branchs,
        CategoryID: catid,
        AppointmentDate: `${year + "-" + monthfixed + "-" + datetrim}`,
        AppointmentAHeadDays: "7",
      };
      axios.post(url, obj).then(
        (response) => {
          this.setState({ data: response.data.appointmentSlots });
          this.setState({
            loader:false
          })
        },
        (error) => {
          console.log(error);
          this.setState({
            loader:false
          })
        }
      );
    }}

  };
  onDateChange = async (date) => {
    this.apiforslots(date._d);
    this.setState({
      dataLoaded: false,
      selectedModalDate: date.format("DD-MM-YYYY"),
    });
  };

  onTimeChange = (time) => {
    var timeStr = time[0].format("hh:mm") + "-" + time[1].format("hh:mm");
    this.startTime = time[0].format("hh:mm");
    this.endTime = time[1].format("hh:mm");
    this.setState({ dataLoaded: false, selectedModalTime: timeStr });
  };

  range = (start, end) => {
    const result = [];
    for (let i = start; i < end; i++) {
      result.push(i);
    }
    return result;
  };

  disabledRangeTime = (_, type) => {
    var now = moment();
    var oneHourAfter = moment().add(1, "hours");
    var prehrs = this.range(0, 23).splice(0, now.format("HH"));
    var prohrs = this.range(0, 23).splice(oneHourAfter);

    var preMins = this.range(0, 59).splice(0, now.format("mm"));
    var proMins = this.range(0, 59).splice(now.format("mm"));

    if (this.state.selectedModalDate == moment().format("YYYY-MM-DD")) {
      if (type === "start") {
        return {
          disabledHours: () => this.range(0, 23).splice(0, now.format("HH")),
          //disabledMinutes: () => this.range(0, 59).splice(0,now.format('mm')),
          disabledMinutes: () => [0, 60],
          //disabledSeconds: () => [55, 56],
        };
      }
      return {
        disabledHours: () => prehrs.concat(prohrs),
        //disabledMinutes: () => preMins.concat(proMins),
        disabledMinutes: () => [0, 60],
      };
    } else {
      return {
        disabledHours: () => [0, 24],
        disabledMinutes: () => [0, 60],
        //disabledSeconds: () => [55, 56],
      };
    }
  };

  render() {
    return (
      <div>
        <Button
          style={{ outline: "none", boxShadow: "none" }}
          variant="link"
          onClick={() => this.handleModalShowHide()}
        >
          {this.state.lang.UnableToFindYourDesiredSlot}
        </Button>

        <Modal show={this.state.showHide} size="lg">
          <Modal.Header closeButton onClick={() => this.handleModalShowHide()}>
            <Modal.Title style={{ marginLeft: "17px" }}>
              {this.state.lang.EnterYourDetailsToInformUs}
            </Modal.Title>
          </Modal.Header>
          <Modal.Body>
            <div className="sl__modal-inner">
              <div className="sl__modal--content">
                <div
                  className="sl__modal_form-row"
                  style={{ marginTop: "-10px" }}
                >
                  <div className="sl__modal_form-col">
                    <label
                      className="sl__modal_form--label"
                      style={{ color: this.UI.fColor }}
                    >
                      {this.state.lang.Name}
                      <span
                        className="estaric"
                        style={{ color: this.UI.requiredEstaricColor }}
                      >
                        *
                      </span>
                    </label>
                    <input
                      onChange={this.onNameChange}
                      type="text"
                      name="name"
                      maxLength={20}
                      placeholder={this.state.lang.Name}
                      id="firstname-field"
                      className="sl__modal_form--input validate-text firstname"
                    />
                    {/* {this.isValidName==false ? <span style={{color: "red"}}>{this.state.lang.NameTypoError}</span> : ''} */}
                  </div>
                </div>

                <div
                  className="sl__modal_form-row"
                  style={{ marginTop: "-10px" }}
                >
                  <div
                    className="sl__modal_form-col telephone-number"
                    style={{ color: this.UI.fColor }}
                  >
                    <label
                      className="sl__modal_form--label "
                      style={{ color: this.UI.fColor }}
                    >
                      {this.state.lang.PhoneNumber}
                      <span
                        className="estaric"
                        style={{ color: this.UI.requiredEstaricColor }}
                      >
                        *
                      </span>
                    </label>
                    <input
                      onChange={this.onPhoneChange}
                      type="text"
                      name="phone"
                      value={this.state.phoneNumber}
                      placeholder={this.state.lang.PhoneNumberPlaceholder}
                      id="phone-field"
                      maxLength={
                        this.userDetailsConfig.phoneNumberField.maxLength
                      }
                      ref={this.phoneNumRef}
                      className="sl__modal_form--input validate-num"
                    />
                    {/* {this.isValidNumber==false ? <span style={{color: "red"}}>{this.state.lang.NumberTypoError}</span> : ''} */}
                  </div>
                </div>

                <div
                  className="sl__modal_form-row"
                  style={{ marginTop: "-10px" }}
                >
                  <div
                    className="sl__modal_form-col"
                    style={{ color: this.UI.fColor }}
                  >
                    <label
                      className="sl__modal_form--label"
                      style={{
                        color: this.UI.fColor,
                      }}
                    >
                      {this.state.lang.EmailAddress}
                      <span
                        className="estaric"
                        style={{ color: this.UI.requiredEstaricColor }}
                      >
                        *
                      </span>
                    </label>
                    <input
                      onChange={this.onEmailChange}
                      type="email"
                      name="email"
                      placeholder={this.state.lang.EmailAddressPlaceHolder}
                      id="email-field"
                      className="sl__modal_form--input"
                    />
                    {/* {this.isValidEmail==false ? <span style={{color: "red"}}>{this.state.lang.EmailTypoError}</span> : ''} */}
                  </div>
                </div>

                <div
                  className="sl__modal_form-row"
                  style={{ marginTop: "-10px" }}
                >
                  <div className="sl__modal_form-col">
                    <label
                      className="sl__modal_form--label"
                      style={{
                        color: this.UI.fColor,
                      }}
                    >
                      {this.state.lang.SelectAppointmentDate}:
                      <span
                        className="estaric"
                        style={{ color: this.UI.requiredEstaricColor }}
                      >
                        *
                      </span>
                    </label>
                    <div
                      className="sl__modal_calendar_input"
                      style={{ float: "left" }}
                    >
                      <ConfigProvider
                        locale={
                          localStorage.getItem("lang") === "es" ? esES : enUS
                        }
                      >
                        <DatePicker
                        placeholder="Select date"
                          onChange={this.onDateChange}
                          // defaultValue={moment()}
                          format={"DD-MM-YYYY"}
                          disabledDate={(current) => {
                            return moment().add(-1, "days") >= current;
                          }}
                          allowClear={false}
                        />
                      </ConfigProvider>
                    </div>
                  </div>

                  <div className="sl__modal_form-col">
                    {/* <label
                      className="sl__modal_form--label"
                      style={{
                        color: this.UI.fColor,
                      }}
                    >
                      {this.state.lang.SelectSlotTime}:
                      <span
                        className="estaric"
                        style={{ color: this.UI.requiredEstaricColor }}
                      >
                        *
                      </span>
                    </label> */}
                    <div
                      className="sl__modal_calendar_input"
                      style={{ float: "left" }}
                    >
                      {/* <ConfigProvider
                        locale={
                          localStorage.getItem("lang") === "es" ? esES : enUS
                        }
                      >
                        <TimePicker.RangePicker
                          onChange={this.onTimeChange}
                          format={"HH:mm"}
                          onCalendarChange={this.firstTimeChange}
                          disabledTime={this.disabledRangeTime}
                        />
                      </ConfigProvider> */}
                    </div>
                  </div>
                </div>
              </div>
            </div>
            <div className="sl__modal-inner">
              <div className="sl__modal--content">
                <div className="sl__modal_calendar-row">
                  {this?.state?.data !== null &&
                  this?.state?.data?.length > 0 ? (
                    this.state?.data?.map((data, index) => {
                      return (
                        <Slot
                          from="Modal"
                          date={data.Date}
                          key={index}
                          timeSlots={data.slotDetail}
                          lang={this.state.lang}
                        />
                      );
                    })
                  ) : (<>
                    {this.state.loader === true ? <Loader/> : <Empty description={this.state.lang.NoSlotsAvailableMsg} />}
                    
                    </>)}
                </div>
              </div>
            </div>
          </Modal.Body>
          <Modal.Footer>
            <PrimaryButton
              onClick={() => this.handleModalShowHide()}
              bgColor={this.UI.btnColor}
            >
              {this.state.lang.Cancel}
            </PrimaryButton>

            <PrimaryButton
              onClick={() => this.saveSlot()}
              bgColor={this.UI.btnColor}
            >
              {this.state.dataLoaded === true ? (
                <i className="fa fa-spinner fa-spin"></i>
              ) : null}{" "}
              &nbsp;
              {this.state.lang.Confirm}
            </PrimaryButton>
          </Modal.Footer>
        </Modal>
      </div>
    );
  }
}

export default SlotModal;
